module.exports = __webpack_public_path__ + "static/media/2.4a80b238.png";